/* import __COLOCATED_TEMPLATE__ from './button.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */
import Component from '@glimmer/component';
import { SideSheetKeys } from 'embercom/objects/workflows/graph-editor/editor-state';
import type EditorState from 'embercom/objects/workflows/graph-editor/editor-state';
import type Workflow from 'embercom/models/operator/visual-builder/workflow';

interface Args {
  editorState: EditorState;
  workflow: Workflow;
}

interface Signature {
  Args: Args;
}

export default class VersionHistoryButton extends Component<Signature> {
  get sideSheetKey() {
    return SideSheetKeys.VersionHistory;
  }

  get shouldShowButton() {
    return Boolean(this.args.workflow.id && this.args.workflow.workflowInstanceEntityId);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::VersionHistory::Button': typeof VersionHistoryButton;
    'workflows/version-history/button': typeof VersionHistoryButton;
  }
}
